import { email, required, Validator } from '@/entities/validation';
import { LoggingInSsoUser } from './model';

export const validate: Validator<LoggingInSsoUser> = user => [
  ...required(user.email, 'email'),
  ...email(user.email, 'email'),
];
